import messages from './myDataDeletion.json' with { type: 'json' };

export const myDataDeletionSv: Readonly<typeof messages> = messages;
